import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// The Fully Funded Shifts head app opens /support-sign-in#<ticket> after one of this provider's admins gave a code.
// The ticket works once, within 60 seconds, from FFS's addresses only (backend support_access.py).
export default function SupportSignIn() {
  const [problem, setProblem] = useState("");
  useEffect(() => {
    const ticket = window.location.hash.slice(1);
    window.history.replaceState(null, "", window.location.pathname);   // the ticket leaves the address bar at once
    if (!ticket) {
      setProblem("This support sign-in link is incomplete. Start the session again from the head app.");
      return;
    }
    api.supportSignIn(ticket)
      .then((r) => {
        localStorage.setItem("token", r.token);
        window.location.replace("/");
      })
      .catch((e) => setProblem(e.response?.data?.detail || "The support sign-in didn't work."));
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center" data-testid="support-sign-in">
        <h1 className="font-display text-2xl text-slate-800">Fully Funded Shifts support</h1>
        <p role={problem ? "alert" : "status"} className="mt-3 text-sm text-slate-600">{problem || "Signing you in…"}</p>
      </div>
    </div>
  );
}
